module.exports = __webpack_public_path__ + "img/receive.d79995c8.png";